// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/climb-speed-altitude-correction.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/climb-speed-altitude-correction/climb-speed-altitude-correction.js';

mount([g0]);
